import { Stack } from '@mantine/core';
import { ChatConversationTileSkeleton } from './chat-conversation-tile-skeleton';

interface IChatConversationTileListSkeletonProps {
  size?: 'sm' | 'md';
  showLastMessages?: boolean;
}

export default function ChatConversationTileListSkeleton({
  size = 'md',
  showLastMessages = true,
}: IChatConversationTileListSkeletonProps) {
  return (
    <Stack>
      {Array.from({ length: 6 }).map((_, index) => (
        <ChatConversationTileSkeleton
          key={index}
          size={size}
          showLastMessage={showLastMessages}
        />
      ))}
    </Stack>
  );
}
